<template>
  <WBDAutoCompleteSelectorFilter
    :filtered-laborer-list="''"
    :remote-list="remoteList"
    :label="label"
    :on-change-event="onChangeEvent"
    :remote-option-value="selectedOptionValue"
    :model-list="modelList"
    hideSearchIcon
    :clear-event="clearEvent"
    @onOfferPublicationStateChange="onOfferPublicationStateChange"
  />
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import WBDAutoCompleteSelectorFilter from '@/components/common/filter/auto-complete-filter'

export default {
  name: 'WBDOfferPublicationStatusSelectorFilter',
  components: { WBDAutoCompleteSelectorFilter },
  props: {
    label: {
      type: String,
      default: 'Публикация'
    },
    remoteOptionValue: {
      type: String,
    },
    remoteList: {
      type: Array,
    },
  },
  data () {
    return {
      loading: false,
      clearEvent: false,
      searchQuery: null,
      selectedOptionValue: null,
      onChangeEvent: 'onOfferPublicationStateChange',
      modelList: [
        {
          id: '1',
          title: 'Опубликован',
        },
        {
          id: '0',
          title: 'Будущий',
        },
      ],
      selectedModelListList: null,

    }
  },
  computed: {
    ...mapGetters({
    }),
    getModelList () {
      return this.modelList
    },
  },
  created () {
    if (this.remoteOptionValue) {
      this.selectedOptionValue = this.remoteOptionValue
    }
    this.clearEvent = this.eventNames.OFFER_PUBLICATION_STATUS_FILTER_RESET
    this.eventsBus.$on(this.clearEvent, () => {
      this.selectedOptionValue = null
      this.searchQuery = null
    })
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
    }),
    onOfferPublicationStateChange (data) {
      this.$emit(
        this.onChangeEvent,
        data
      )
    },
  }
}
</script>
